import React from "react";
import withLayout from "../../../components/desktop/layout/component";
import withReducer from "../../../components/shared/with-reducer";
import RTOInfo from "../../../components/desktop/rto-info";
import injectableReducers from "./injectable";

const mapStateToProps = () => ({});

const RTO = () => <RTOInfo />;

export default withReducer(injectableReducers)(mapStateToProps, dispatch => ({ dispatch }))(
    withLayout(RTO, true, true, false, true)
);

